<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Merge Member
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-header">
        Please select the address hub should belong to
      </div>
      <div class="flex-row margin-top-4">
        <div class="flex-1">
          UID
        </div>
        <div class="flex-1">
          Address
        </div>
      </div>
      <div
        v-for="hub in mergeForm"
        :key="hub.uId"
        class="flex-row align-center margin-top-4"
      >
        <div class="flex-1">
          {{ hub.uId }}
        </div>
        <div class="flex-1">
          <SACDropdown
            showSearch
            :options="addressOptions"
            :value="hub.serviceAddressId"
            placeholder="Select Address"
            :change="(field, value) => selectMergeHubAddress(hub.uId, value)"
          />
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="mergeMember"
      >
        Submit
      </button>
    </div>
    <ProcessOverlay
      :show="mergingMember"
      text="Merging Members"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'MergeMemberForm',
  components: {
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  computed: {
    addressOptions() {
      const toAddress = this.selectedMergeCustomer.serviceAddress;
      const fromAddress = this.customer.serviceAddress;
      const allAddress = toAddress.concat(fromAddress);
      return allAddress.map((address) => {
        const {
          id,
          address1,
        } = address;
        return {
          label: `${address1}`,
          value: id,
        };
      });
    },
  },
  methods: {
    selectMergeHubAddress(uId, id) {
      const newMergeForm = this.mergeForm.map((hub) => {
        const {
          uId: uid,
        } = hub;
        if (uid === uId) {
          return {
            ...hub,
            serviceAddressId: id,
          };
        }
        return hub;
      });
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'mergeForm',
        value: newMergeForm,
      });
    },
    async mergeMember() {
      await this.$store.dispatch('mergeMember');
      this.$router.push(`/member/${this.selectedMergeCustomer.customerId}`);
      this.toggleActionModal(false);
    },
  },
};
</script>
